import { assetVariantAtom } from '../lendAndBorrow';
import { Decimal } from '../../datastructures';
import poolsUserBalanceAtom from '../pool/poolsUserBalanceAtom';
import { walletAddressAtom } from '../wallet';
import { poolsAprAtom } from '../pool';
import poolRewardsAprAtom from '../pool/poolRewardsAprAtom';
import { createAsyncAtom } from '../../lib/state';
import lendAndBorrowPositionsAtom from './lendAndBorrowPositions';

function projectYieldOver30Days(balance: Decimal, apy: Decimal) {
  return balance.mul(apy).div(365).mul(30);
}

const userProjectedYieldAtom = createAsyncAtom(async get => {
  const lendAndBorrowPositions = await get(lendAndBorrowPositionsAtom);
  const poolPositions = await get(poolsUserBalanceAtom);
  const assetVariantMap = await get(assetVariantAtom);
  const walletAddress = await get(walletAddressAtom);
  const poolsApr = await get(poolsAprAtom);
  const poolRewards = await get(poolRewardsAprAtom);

  if (!assetVariantMap || !walletAddress || !lendAndBorrowPositions) {
    return {
      lend: Decimal.ZERO,
      pools: Decimal.ZERO,
    };
  }

  let lendProjectedYield = new Decimal(0);
  Object.entries(lendAndBorrowPositions).forEach(([, accountPositions]) => {
    accountPositions.forEach(position => {
      const assetVariant = assetVariantMap[`${walletAddress}-${position.accountId}-${position.asset.address}`];
      if (assetVariant?.isLending) {
        lendProjectedYield = lendProjectedYield.add(position.projectedYield);
      }
    });
  });

  let poolsProjectedYield = Decimal.ZERO;
  Object.entries(poolPositions).forEach(([poolPairId, value]) => {
    const poolApy = poolsApr[poolPairId];
    const poolReward = poolRewards[poolPairId] || Decimal.ZERO;

    poolsProjectedYield = poolsProjectedYield.add(projectYieldOver30Days(value, poolApy.add(poolReward)));
  });

  return {
    lend: lendProjectedYield,
    pools: poolsProjectedYield,
  };
});

export default userProjectedYieldAtom;
